var audio_rtlignore_default = {
  "fontElementMap": "vZjRF",
  "container": "lWXwe",
  "customPlayer": "itPaU",
  "slim": "Ll7JM",
  "playPauseButton": "kQmBk",
  "coverImage": "JhYsg",
  "trackDetailsContainer": "_8FcUN",
  "controlsContainer": "_0mejY",
  "controlsGroup": "sthL1",
  "sliderContainer": "o7obx",
  "audioDuration": "_1tsQq",
  "isLoading": "_1pZRV",
  "audioDetails": "YxpyY",
  "authorName": "G7iFG",
  "title": "kYQII",
  "dropdownMenuWrapper": "IiR4x",
  "dropdownSelectedButton": "Oqcee",
  "dropdownContent": "eCLNT",
  "dropdownContentWithIcon": "Y-VI8",
  "audioLoader": "R2o5A"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
